import { ActionType, getType } from "typesafe-actions";
import { uniqBy, sortBy } from "lodash";

import * as fetchOrderActions from "./actions";
import * as createDirectOrderActions from "../bookDirect/actions";
import { BookDirectAction } from "../bookDirect/reducer";
import * as createMultiOrderActions from "../bookMulti/actions";
import { BookMultiAction } from "../bookMulti/reducer";
import { OrdersState } from "./model/OrdersState";
import { OrdersFilter } from "../../lib/model/OrdersFilter";

export type FetchOrdersAction = ActionType<typeof fetchOrderActions>;

const initialState: OrdersState = {
  openOrders: {
    results: [],
    cursors: {}
  },
  completedOrders: {
    results: [],
    cursors: {}
  },
  searchResults: {
    results: [],
    cursors: {}
  },
  isLoadingOrders: false,
  selectedFilter: OrdersFilter.Open
};

export default (
  state: OrdersState = initialState,
  action: FetchOrdersAction | BookDirectAction | BookMultiAction
): OrdersState => {

  switch (action.type) {
    case getType(fetchOrderActions.fetchOrdersAsync.request):
      return { ...state, isLoadingOrders: true, selectedFilter: action.payload.filter };
    case getType(fetchOrderActions.searchOrdersAsync.request): 
      return { ...state, isLoadingOrders: true };
    case getType(fetchOrderActions.fetchOrdersAsync.success): {
      if (state.selectedFilter === OrdersFilter.Open) {
        return { 
          ...state,
          openOrders: {
            results: 
            sortBy(
              uniqBy([...state.openOrders.results, ...action.payload.results], 'id'),
              ['order', 'endTime', 'startTime']).reverse(),
            cursors: {...action.payload.cursors}
          },
          isLoadingOrders: false,
        };
      }

      return { 
        ...state,
        completedOrders: {
          results: sortBy(
            uniqBy([...state.completedOrders.results, ...action.payload.results], 'id'),
            ['order', 'endTime', 'startTime']).reverse(),
          cursors: {...action.payload.cursors}
        },
        isLoadingOrders: false,
      };
    }
    case getType(fetchOrderActions.fetchOrdersAsync.failure):
    case getType(fetchOrderActions.searchOrdersAsync.failure):
      return { ...state, isLoadingOrders: false };
    case getType(createDirectOrderActions.createOrderAsync.success):
    case getType(createMultiOrderActions.createOrderAsync.success):
        return { 
          ...state,
          openOrders: {
            results: 
            sortBy(
              uniqBy([...state.openOrders.results, action.payload], 'id'),
              ['order', 'endTime', 'startTime']).reverse(),
            cursors: state.openOrders.cursors
          },
          isLoadingOrders: false,
        };
    case getType(fetchOrderActions.searchOrdersAsync.success): {
      return { 
        ...state,
        searchResults: {
          results: action.payload,
          cursors: {}
        },
        isLoadingOrders: false,
      };
    }
    default:
      return state;
  }
};
